export type ICashbackMainPageResources = typeof CashbackMainPageResources;

export const CashbackMainPageResources = {
    cashbackProcessSteps: {
        mobilesTitle: "Cashback krok po kroku",
        buttonTextClose: "Pokaż mniej",
        buttonTextOpen: "Pokaż więcej",
        stepper: {
            step1Title: "Zaczynasz od goodie",
            step1Description:
                "Zaloguj się w goodie cashback na stronie goodie.pl lub w aplikacji mobilnej goodie.",
            step2Title: "Wybierasz sklep i kupujesz",
            step2Description:
                "W goodie wybierz sklep i naciśnij 'Przejdź do sklepu', a następnie złóż zamówienie i dokonaj płatności - tak jak zawsze!",
            step3Title: "Otrzymujesz zwrot",
            step3Description:
                "Wysokość zwrotu znajdziesz na Twoim koncie w goodie. Po potwierdzeniu zakupu przez sklep, środki zostaną zaakceptowane do wypłaty.",
            step4Title: "Dostajesz gotówkę na konto",
            step4Description:
                "Po uzbieraniu min. 21 zł cashbacku możesz zlecić przelew środków na konto w dowolnym banku.",
        },
    },
    transactionsList: {
        tableHeader1: "ZAMÓWIENIE",
        tableHeader1Withdrawal: "STATUS",
        tableHeader2: "DATA ZAMÓWIENIA",
        tableHeader2Mobile: "DATA",
        tableHeader3: "WARTOŚĆ ZAMÓWIENIA",
        tableHeader4: "KWOTA ZWROTU",
        tableHeader4Withdrawal: "KWOTA",
        emptyPendingTransactionsTitle: "Nie masz jeszcze oczekujących transakcji",
        emptyPendingTransactionsDescription1:
            "Tu pojawi się cashback za dokonane przez Ciebie zakupy, który jeszcze nie został potwierdzony przez sklep.",
        emptyPendingTransactionsDescription2:
            "Czas oczekiwania na zatwierdzenie zależy od sklepu. Średni czas oczekiwania można sprawdzić w opisie sklepu w goodie.",
        emptyApprovedTransactionsTitle: "Nie masz jeszcze zatwierdzonych transakcji",
        emptyApprovedTransactionsDescription1:
            "Tu pojawią się potwierdzone przez sklepy zwroty cashback, z których możesz dokonać wypłaty.",
        emptyApprovedTransactionsDescription2:
            "Wypłata jest możliwa po zgromadzeniu co najmniej 21 zł zwrotu cashback.",
        emptyWithdrawalsTransactionsTitle: "Nie masz jeszcze wypłat",
        emptyWithdrawalsTransactionsDescription1:
            "Tu pojawią się informacje o dokonanych wypłatach cashback.",
        emptyWithdrawalsTransactionsDescription2:
            "Przelew z wypłatą zajmuje zwykle nie więcej niż 3 dni robocze.",
        emptyRejectedTransactionsTitle: "Nie masz jeszcze odrzuconych transakcji",
        emptyRejectedTransactionsDescription:
            "Tu pojawią się informacje o transakcjach odrzuconych wraz z podaniem przyczyny.",
        cashbackLinkTitle: "Zgłoś brakującą transakcję!",
        pendingBtn: "Oczekujące",
        approvedBtn: "Zatwierdzone",
        withdrawalBtn: "Wypłaty",
        rejectedBtn: "Odrzucone",
    },
    transactionsManager: {
        modalTitle: "Twoje transakcje w goodie",
        showAllText: "Wszystkie transakcje",
        faqText: "Pytania i odpowiedzi",
        allShopsText: "Wszystkie sklepy ⬇",
    },
    cashbackDashboard: {
        totalAmountWithdrawalText: "Łączny wypłacony cashback",
        cashbackWithdrawForm: {
            title: "Wypłata środków",
            amountLabel: "Wypłacasz",
            firstLastNameLabel: "Imię i nazwisko",
            firstLastNameWatermarkText: "podaj imię i nazwisko",
            accountNumberWatermarkText: "podaj numer rachunku",
        },
    },
    bannerSectionTitle: "Gorące okazje",
    brandsCashbackSection: {
        titleFavorites: "Ulubione sklepy cashback",
        addMoreFavoritesText: "Dodaj sklep",
        titleBrands: "Wszystkie sklepy cashback",
        searchText: "Wyszukaj sklep cashback",
        noBrandsText:
            "Obecnie nie ma sklepów przypisanych do tej kategorii w goodie cashback. Możesz znaleźć podobne sklepy ze zwrotem cashback klikając powyżej na odpowiednią kategorię.",
        filterText: "Sortowanie:",
        filterOptionAlphabetic: "Alfabetycznie",
        filterOptionPopular: "Najpopularniejsze",
    },
};
